<template>
  <span
    :style="skeletonStyle"
    class="SkeletonBox"
    :class="$props.circle ? 'circle' : ''"
  ></span>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    circle: {
      default: false,
      type: Boolean,
    },
    maxWidth: {
      default: 100,
      type: Number,
    },
    minWidth: {
      default: 80,
      type: Number,
    },
    height: {
      default: '1em',
      type: String,
    },
    width: {
      default: null,
      type: String,
    },
    borderRadius: {
      type: String,
      default: '10px',
    },
    backgroundColor: {
      type: String,
      default: '#e0e0e0',
    },
  },
  computed: {
    computedWidth() {
      // Either use the given fixed width or
      // a random width between the given min
      // and max values.
      return (
        this.width ||
        `${Math.floor(
          Math.random() * (this.maxWidth - this.minWidth) + this.minWidth,
        )}%`
      );
    },
    skeletonStyle() {
      return {
        height: this.height,
        width: this.computedWidth,
        borderRadius: this.borderRadius,
        backgroundColor: this.backgroundColor,
      };
    },
  },
};
</script>

<style lang="scss">
.SkeletonBox {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;

  &.circle {
    border-radius: 50% !important;
  }
  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    border-radius: 10px;
    background-image: linear-gradient(
      90deg,
      rgba(150, 150, 150, 0) 0,
      rgba(150, 150, 150, 0.2) 20%,
      rgba(150, 150, 150, 0.5) 60%,
      rgba(150, 150, 150, 0)
    );
    animation: shimmer 3s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
